import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CreateButton from '../buttons/CreateButton';
import withPrivileges from '../../hocs/withPrivileges';
import Privileges from '../../utils/Privileges';
import MemberCreateTab from './MemberCreateTab';
import { memberPropertiesType } from '../../types';

CreateMemberRow.propTypes = {
    memberProps: memberPropertiesType.isRequired,
};

function CreateMemberRow(props) {
    const {
        memberProps,
    } = props;
    const { t } = useTranslation();
    const [isCreateVisible, setCreateVisible] = useState(false);
    const actionHandler = () => setCreateVisible(!isCreateVisible);
    return (
        <div className="create-member-row">
            <CreateButton onAction={actionHandler} isCreateVisible={isCreateVisible}>
                <FontAwesomeIcon icon="plus" />&nbsp;{t('members.create-member')}
            </CreateButton>
            {isCreateVisible && <MemberCreateTab memberProps={memberProps} hideHandler={() => setCreateVisible(false)} />}
        </div>
    );
}

export default withPrivileges([Privileges.MEMBER_EDIT])(CreateMemberRow);
